<template>
  <div v-if="visible" class="popup">
    <div class="bg"></div>
    <div class="popupInner">
    <div class="title">
      <div>{{$t('components.popupInvoice.title')}}</div>
      <img src="../assets/images/close.png" class="closeIcon" @click="closePopup"/>
    </div>
      <div class="ul">
      <div class="li">
      <label><span>*</span>{{$t('components.popupInvoice.invoice_type')}}</label>
      <div class="tabBtns">
            <div class="tabBtn invoiceBtn"  :class="{active: invoice == 1}" @click="invoiceClick(1)"><div class="orange">{{$t('components.popupInvoice.char_special')}}</div>{{$t('components.popupInvoice.type_special')}}
          <img  src="../assets/images/gou.png" v-if="invoice ==1"/>
          </div>
          <div class="tabBtn invoiceBtn"  :class="{active: invoice == 2}" @click="invoiceClick(2)"><div class="blue">{{$t('components.popupInvoice.char_general')}}</div>{{$t('components.popupInvoice.type_general')}}
          <img  src="../assets/images/gou.png"  v-if="invoice ==2"/>
          </div>
        </div>
      </div>
        <div class="li">
          <label><span>*</span>{{$t('components.popupInvoice.invoice_head')}}</label>
          <div>
              <input type="text"  required  v-model="memberInfo.invoice_head"/>
             <span  class="warningText"></span>
            </div>
        </div>
        <div class="li">
          <label><span>*</span>{{$t('components.popupInvoice.invoice_taxno')}}</label>
           <div>
             <input type="text"  required v-model="memberInfo.invoice_taxno" />
             <span  class="warningText"></span>
          </div>

        </div>
         <div class="li">
          <label><span>*</span>{{$t('components.popupInvoice.invoice_register_address')}}</label>
          <div>
            <input type="text"  required  v-model="memberInfo.invoice_register_address"/>
            <span class="warningText"></span>
          </div>
        </div>
         <div class="li">
          <label><span>*</span>{{$t('components.popupInvoice.invoice_register_mobile')}}</label>
           <div>
            <input type="text"  required  v-model="memberInfo.invoice_register_mobile"/>
            <span  class="warningText"></span>
          </div>
        </div>
        <div class="li">
          <label><span>*</span>{{$t('components.popupInvoice.invoice_branch')}}</label>
           <div>
            <input type="text"  required  v-model="memberInfo.invoice_branch"/>
            <span  class="warningText"></span>
          </div>
        </div>
        <div class="li">
          <label><span>*</span>{{$t('components.popupInvoice.invoice_accountno')}}</label>
            <div>
             <input type="text"  required v-model="memberInfo.invoice_accountno"/>
            <span class="warningText"></span>
          </div>
        </div>
      </div>
      <div class="btns">
        <div class="btnStyle saveBtn" @click="closePopupSave">{{$t('components.popupInvoice.btnSave')}}</div>
        <div class="btnStyle cancelBtn" @click="closePopup">{{$t('components.popupInvoice.btnCancel')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import imgSwiper from './imgSwiper.vue';
	export default{
	components: { imgSwiper },
		props:{
		  visible:{
			type:Boolean,
			default: false
		  },
		  selectId:{
				type: Number,
				default:0
			}
		},
		data(){ 
			return{ 
				invoice:0,
				memberInfo:{},
			}  
		},
		mounted() {
			this.GetMemberInfo();
		},
		methods:{
			closePopupSave(){
				let that=this;
				this.$scUtil.axiosPut(this, 'MemberApi/UpdateInvoice', {
					invoice_type:this.invoice,
					invoice_head:this.memberInfo.invoice_head,
					invoice_taxno:this.memberInfo.invoice_taxno,
					invoice_register_address:this.memberInfo.invoice_register_address,
					invoice_register_mobile:this.memberInfo.invoice_register_mobile,
					invoice_branch:this.memberInfo.invoice_branch,
					invoice_accountno:this.memberInfo.invoice_accountno,
					userName: localStorage.getItem('username'),
				}, res => {
					//console.log(res.code);
					if (res.code == 100) {
						this.$message({
							message: res.message,
							type: "success"
						});
						that.$emit('close');
						that.GetMemberInfo();
					}
					else
					{
						this.$message({
							message: res.message,
							type: "warning"
						});
					}
				});
			},
			closePopup(){
				
				this.$emit('close');
			},
			invoiceClick(idx){
				this.invoice = idx;
			},
			GetMemberInfo()
			{
				this.$scUtil.axiosPost(this, 'MemberApi/GetMemberInvoice', {
					userName: localStorage.getItem('username'),
				}, res => {
					//console.log(res.code);
					if (res.code == 100) {
						this.memberInfo = res.data;
						this.invoice=this.memberInfo.invoice_type
						//console.log(JSON.stringify(this.memberInfo))
					}
				
				});
			}
		}
	}
</script>

<style scoped>
  .bg{
    background-color: rgba(0, 0, 0, 0.4);
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
  }

  .popup{
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    position: fixed;
    top: 0;
    left: 0;
  }

  .popupInner{
    background: #fff;
    width: 725px;
    border-radius: 15px;
    z-index: 999;
  }

  .title{
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: #222;
    padding: 0 15px;
  }

  .ul{
    padding: 20px 70px 0 70px;
    box-sizing: border-box;
  }

  .ul .li{
    min-height: 65px;
    display: flex;
    align-items: baseline;
    font-size: 13px;
    color: #333;
  }

  .ul .li label{
    white-space: nowrap;
    width: 120px;
    min-width: 120px;
    text-align: right;
    margin-right: 10px;
  }

  .ul .li span{
    color: #f74848;
  }

  .ul .li input{
    width: 450px;
    height: 36px;
    border: 1px solid #d9d9d9;
    padding: 0 10px;
    box-sizing: border-box;
  }

  .ul .li input.red{
     border: 1px solid #f74848;
  }

  .warningText{
    font-size: 12px;
  }

  .btns{
    cursor: pointer;
    display: flex;
    padding-left: 200px;
    margin-bottom: 20px;
  }

  .btnStyle{
    width: 91px;
    height: 44px;
    font-size: 12px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .saveBtn{
    border: 1px solid #0380fe;
    background: #0380fe;
    color: #fff;
    margin-right: 20px;
  }

  .cancelBtn{
    border: 1px solid #d9d9d9;
    background: #fff;
    color: #333;
  }


	.tabBtns{
		display: flex;
		align-items: center;
	}

	.tabBtn{
		height: 30px;
		line-height: 30px;
		padding: 0 17px;
		font-size: 14px;
		color: #333333;
		border: 1px solid #cccccc;
		border-radius: 5px;
		position: relative;
		margin-right: 18px;
	}

	.tabBtn.active{
		border: 1px solid #0380fe;
	}

	.tabBtn img{
		position: absolute;
		bottom: 0px;
		right: 0px;
	}

	.invoiceBtn{
		display: flex;
		align-items: center;
	}


	.invoiceBtn .orange{
		width: 22px;
		height: 22px;
		color: #fff;
		background-color: #ff8d50;
		border-radius: 5px;
		font-size: 13px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 9px;
	}

	.invoiceBtn .blue{
		width: 22px;
		height: 22px;
		color: #fff;
		background-color: #0380fe;
		border-radius: 5px;
		font-size: 13px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 9px;
	}

</style>